import { useTranslation } from 'react-i18next';

import { SafeNavLink } from "@/components/SafeLink";
import { useSelector } from "react-redux";
import { Avatar, Button } from '@mui/material';

import styles from "./header.module.scss";
import { ReactComponent as BackIcon } from '@/assets/icons/backIcon.svg'
import { ReactComponent as ClivLogo } from '@/assets/icons/c-liv_logo.svg';
import { ReactComponent as LogoutIcon } from '@/assets/icons/logout.svg';
import { RootState } from '@/store/rootReducer';
import store from '@/store/store';
import { logout } from '@/store/slices/authSlice';
import { API_ENDPOINTS } from '@/api/endpoints.constant';
import { systemConfig } from '@/config/systemConfig';
import { ApiRequestOptions } from '@/types/ApiRequestOptions';
import { clivApiRequest } from '@/utils/apiClient';
import { useAppSelector } from '@/store/hooks';
import { SyncStatus } from '@/enums/SyncStatus.enum';
import { toast } from 'react-toastify';

export interface headerProps {
    title: string;
    enableBack: boolean;
    isBlocked?: boolean;
    onBlockedNavigation?: () => void;
}

export const Header = (props: headerProps) => {
    const { enableBack, isBlocked = false, onBlockedNavigation } = props;
    const headerText = useSelector((state: RootState) => state.appData.page?.header || '');
    const { t: translate } = useTranslation();
    const syncStatus = useAppSelector((state) => state.uploadProgress?.status);
    const env = systemConfig.environment?.toLowerCase();
    const headerBgColor = env === 'uat' ? '#1976D2' : env === 'dev' ? '#04C1A2' : '#198754';

    const handleLogout = () => {
        // Check if navigation is blocked
        if (isBlocked) {
            if (onBlockedNavigation) {
                onBlockedNavigation();
            }
            return;
        }
        if (syncStatus === SyncStatus.IN_PROGRESS) {
            toast.error(translate('syncInProgress'));
            return;
        }

        performLogout();
    };

    const performLogout = async () => {
        const url = `${systemConfig.apiUrl}/${API_ENDPOINTS.AUTH.LOGOUT}`;
        const apiRequest: ApiRequestOptions = {
            url: url,
            body: {},
            method: 'GET'
        };

        const response = await clivApiRequest<void>(apiRequest);
        if (response.ok) {
            store.dispatch(logout());
        }
    };



    return (
        <header className={styles.header} id='navbar' style={{ backgroundColor: headerBgColor }}>
            <div className={styles.headerContent}><SafeNavLink to={'/'} isBlocked={isBlocked} onBlockedNavigation={onBlockedNavigation}>
                <div className={styles.headerLogo}>
                    {enableBack && <Button sx={{ padding: 'unset' }} startIcon={<BackIcon />}></Button>}
                    <ClivLogo />
                </div>
            </SafeNavLink>
                <div className={styles["header-logo"]}>{translate(headerText)}</div>
                <Avatar onClick={handleLogout} alt="User" className={styles.logoutIcon}><LogoutIcon /></Avatar>
            </div>
            <div className={styles.version}> {systemConfig.version}</div>
        </header >
    );
}



